import { render, staticRenderFns } from "./SrMasterTaskType.vue?vue&type=template&id=0945cbf1"
import script from "./SrMasterTaskType.vue?vue&type=script&lang=js"
export * from "./SrMasterTaskType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports